<template>
  <div class="layout-content-list">
    <el-breadcrumb separator=">" class="bc-nav mb-20">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>货源</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/bookSchedule' }"> 报号计划 </el-breadcrumb-item>
      <el-breadcrumb-item> 报号详情 </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="table-custom-box">
      <div class="segment statistics">
        <div class="segment-area segment-item-box">
          <div class="segment-item">
            <span class="name">装货地名称：</span>
            <span class="dec" id="auto-0">{{ bookDtl.sourceAddressName }}</span>
          </div>
          <div class="segment-item">
            <span class="name"> 卸货地名称：</span>
            <span class="dec" id="auto-1">{{ bookDtl.targetAddressName }}</span>
          </div>
          <div class="segment-item">
            <span class="name"> 运费单价（元/吨）：</span>
            <span class="dec" id="auto-2">{{ bookDtl.unitPrice }}</span>
          </div>
          <div class="segment-item">
            <span class="name"> 要车数量（车）：</span>
            <span class="dec" id="auto-3">{{ bookDtl.needCarNum === null ? '不限' : bookDtl.needCarNum }}</span>
          </div>
          <div class="segment-item" v-if="bookDtl.bookCloseTime">
            <span class="name"> 报号截止日期：</span>
            <span class="dec" id="auto-4">{{ bookDtl.bookCloseTime | stamp2TextDateFull(2) }}</span>
          </div>
          <div class="segment-item">
            <span class="name"> 装车开始日期：</span>
            <span class="dec" id="auto-5">{{ bookDtl.loadTime | stamp2TextDateFull(2) }}</span>
          </div>
          <div class="segment-item">
            <span class="name"> 装车截止日期：</span>
            <span class="dec" id="auto-6">{{ bookDtl.loadCloseTime | stamp2TextDateFull(2) }}</span>
          </div>
        </div>
      </div>
      <div class="mt-20">
        <el-button type="primary" round size="small" id="auto-7" @click="handleEdit" v-if="bookDtl.editableType !== 0">
          编辑</el-button
        >
        <el-button type="danger" round size="small" id="auto-8" @click="handleDel" v-if="bookDtl.deletable">
          删除</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:8
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/stock.new.api.js';
import { WUYI, vali } from '@/api/common';
export default {
  data() {
    return {
      bookDtl: {},
      id: ''
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.search();
  },
  methods: {
    search() {
      axios.post(api.queryBookScheduleDetail, { callSource: 1, id: this.id }).then(res => {
        this.bookDtl = res.data;
      });
    },
    handleEdit() {
      this.$router.push(`/bookScheduleChange/edit/${this.id}`);
    },
    handleDel() {
      this.$confirm('确定要删除这个计划吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          axios.post(api.deleteBookSchedule, { callSource: 1, id: this.id }).then(res => {
            this.$message.success('删除成功');
            this.$router.push('/bookSchedule');
          });
        })
        .catch(() => {});
    }
  }
};
</script>
<style scoped>
.segment-item .name {
  color: gray;
  font-size: 14px;
  /* margin: 10px 10px; */
  line-height: 40px;
}
</style>
